"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USERS = void 0;
/** List of known users */
exports.USERS = [
    "Matt", "Alice", "Lauren", "Ali", "Antonio", "Edison", "Andrew", "Katherine",
    "Jonathan", "Omar", "Riva", "Mayee", "Anmol", "Saan", "Lawrence", "Connor", "Helena", "Yusong"
    // Feel free to change this list to your friends
    // (or just your favorite of the 331 staff)
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlcnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXNlcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsMEJBQTBCO0FBQ2IsUUFBQSxLQUFLLEdBQWtCO0lBQ2xDLE1BQU0sRUFBRSxPQUFPLEVBQUUsUUFBUSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFBRSxXQUFXO0lBQzVFLFVBQVUsRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxFQUFFLFVBQVUsRUFBRSxRQUFRLEVBQUUsUUFBUSxFQUFFLFFBQVE7SUFDOUYsZ0RBQWdEO0lBQ2hELDJDQUEyQztDQUM1QyxDQUFDIn0=